/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { tagName } from '@ember-decorators/component';
import { tracked } from '@glimmer/tracking';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { saveOrDiscard } from '@linc-technologies/linced-common/utils/record-rollback';

@tagName('')
export default class GoalCard extends Component {
  // Services
  @service
  router;

  @service
  session;

  @service
  store;

  @service
  toaster;

  GoalState = GoalState;

  @computed('state.awarded')
  get clickable() {
    return !this.state || this.state.awarded === GoalState.NOT_SET;
  }

  @computed('clickable')
  get contentClasses() {
    if (this.clickable) {
      return 'layout-row layout-align-start-start clickable';
    } else {
      return 'layout-row layout-align-start-start';
    }
  }

  @computed('state.awarded')
  get stateClass() {
    if (this.state) {
      switch (this.state.awarded) {
        case GoalState.DEVELOPING:
          return 'goal-developing';
        case GoalState.SECURE:
          return 'goal-secure';
      }
    }
    return '';
  }

  @tracked
  selectedGoal = null;
  @tracked
  showExemplar = false;

  @tracked
  state;

  @action
  handleUpdateState(goal, previousState) {
    // Do nothing if we aren't supposed to be clickable.
    if (!this.clickable) {
      return;
    }

    // If the Goal is already "developing" or "secure", don't do anything.
    switch (previousState) {
      case GoalState.DEVELOPING:
      case GoalState.SECURE:
        return;
    }

    // Goal is not currently set.  Set it to "developing".
    let newState = this.store.createRecord('goals/state', {
      schoolId: this.get('session.school'),
      assessorId: this.get('session.person'),
      personId: this.get('session.person'),
      goalId: goal,
      awarded: GoalState.DEVELOPING,
    });

    saveOrDiscard(newState)
      .then(() => {
        this.state = newState;
        if (this.onStateChange) {
          this.onStateChange(newState);
        }
      })
      .catch(() => this.toaster.error('Error saving the goal state.'));
  }

  @action
  onClose() {
    this.showExemplar = false;
  }

  @action
  openExemplar(selectedGoal) {
    this.selectedGoal = selectedGoal;
    this.showExemplar = true;
  }
}
